var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    sessionItemResultPadding: spacing.small,
    topBorderWidth: borders.widthSmall,
    topBorderColor: colors.tiara,
    resultMargin: spacing.small,
    pointsColor: colors.ash,
    pointFontSize: typography.fontSizeXSmall,
    questionFontSize: typography.fontSizeMedium,
    itemFeedbackWrapperMargin: spacing.small,
    itemFeedbackWrapperPadding: spacing.xSmall,
    itemFeedbackWrapperBorderRadius: borders.radiusMedium,
    itemFeedbackWrapperFontSize: typography.fontSizeSmall,
    itemFeedbackWrapperBorderStyle: borders.borderStyle,
    itemFeedbackWrapperBorderWidth: borders.widthSmall,
    itemFeedbackWrapperBorderColor: colors.tiara,
    itemFeedbackWrapperStyle: borders.style,
    itemFeedbackLabelColor: colors.oxford,
    itemFeedbackLabelFontSize: typography.fontSizeXSmall,
    itemFeedbackMargin: spacing.xxSmall,
    itemFeedbackTextSize: typography.fontSizeMedium,
    itemFeedbackTextMargin: spacing.xxxSmall,
    textPaddingLeft: spacing.small,
    textPaddingBottom: spacing.small
  };
};
export default generateComponentTheme;